import { Box, useTheme } from '@mui/material';

import screenshot1 from '../../assets/screenshots/2759.jpg';
import screenshot2 from '../../assets/screenshots/2760.jpg';
import screenshot3 from '../../assets/screenshots/2761.jpg';
import screenshot4 from '../../assets/screenshots/2762.jpg';
import screenshot5 from '../../assets/screenshots/2763.jpg';
import screenshot6 from '../../assets/screenshots/2764.jpg';

const screenshots = [
  screenshot1,
  screenshot2,
  screenshot3,
  screenshot4,
  screenshot5,
  screenshot6,
];

export const ScreenshotsGallery = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        mt: { xs: 6, md: 8 },
        mx: { xs: -2, sm: -3, md: -6, lg: -8 },
        position: 'relative',
      }}
    >
      {/* Gradient fade edges */}
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: { xs: 40, md: 80 },
          background: isDark
            ? 'linear-gradient(to right, rgba(20,20,36,1), rgba(20,20,36,0))'
            : 'linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0))',
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          width: { xs: 40, md: 80 },
          background: isDark
            ? 'linear-gradient(to left, rgba(20,20,36,1), rgba(20,20,36,0))'
            : 'linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0))',
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />

      {/* Scrollable container */}
      <Box
        sx={{
          overflowX: 'auto',
          overflowY: 'hidden',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          px: { xs: 4, sm: 6, md: 10, lg: 12 },
          py: { xs: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 2, sm: 2.5, md: 3 },
            width: 'max-content',
            mx: 'auto',
          }}
        >
          {screenshots.map((screenshot, index) => (
            <Box
              key={index}
              component="img"
              src={screenshot}
              alt={`Calorium App Screenshot ${index + 1}`}
              sx={{
                width: { xs: 180, sm: 200, md: 220, lg: 240 },
                height: 'auto',
                borderRadius: { xs: '24px', sm: '28px', md: '32px' },
                boxShadow: '0 20px 40px -10px rgba(0, 0, 0, 0.15)',
                flexShrink: 0,
                transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  transform: 'scale(1.03) translateY(-8px)',
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
